import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { DropDownSetting } from '~/models/administration/dropDownSetting';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class DropDownSettingsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.settings);
    }

    getDropDownSettings() {
        return this.http.get<DropDownSetting>(this._url());
    }

    updateDropDownSettings(model: any) {
        return this.client.put(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/DropDownSettings${v}`);
    }
}
